import { AppFullCodeLocale, AppLocale } from '@core-types/app-locale';

export const DEFAULT_LOCALE: AppLocale = 'en';
export const DEFAULT_FULL_CODE_LOCALE: AppFullCodeLocale = 'en-US';
